import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import PageContainer from '../components/layout/PageContainer';
import LoadingSpinner from '../components/common/LoadingSpinner';

interface Event {
  id: string;
  title: string;
  image: string;
  category: string;
  date: string;
  author: string;
  summary: string;
  content: string;
}

const EventsList = () => {
  const [events, setEvents] = useState<Event[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch('https://us-central1-appdizquetem.cloudfunctions.net/getEventList');
        const data = await response.json();
        setEvents(data);
      } catch (error) {
        console.error('Error loading events:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  if (loading) {
    return (
      <PageContainer>
        <div className="flex items-center justify-center min-h-[calc(100vh-64px)]">
          <LoadingSpinner />
        </div>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-semibold text-white">
          Eventos
        </h1>
      </div>

      <div className="space-y-4">
        {events.map((event, index) => (
          <motion.div
            key={event.id}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: index * 0.1 }}
          >
            <Link
              to={`/events/${event.id}`}
              className="block bg-white/10 backdrop-blur-lg rounded-xl overflow-hidden hover:bg-white/20 transition-colors"
            >
              <div className="flex flex-col md:flex-row">
                <div className="w-full md:w-48 h-48 md:h-auto">
                  <img
                    src={event.image}
                    alt={event.title}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-4 flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="text-primary text-sm font-medium">
                      {event.category}
                    </span>
                    <span className="text-white/40 text-sm">
                      {new Date(event.date).toLocaleDateString('pt-BR')}
                    </span>
                  </div>
                  <h2 className="text-white font-medium text-lg mb-2">
                    {event.title}
                  </h2>
                  <p className="text-white/60 text-sm">
                    {event.summary}
                  </p>
                  <div className="mt-2 text-white/40 text-sm">
                    Por {event.author}
                  </div>
                </div>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
    </PageContainer>
  );
};

export default EventsList; 